export default __webpack_public_path__ + "static/media/Prologue_Aurora2.456aafc5.svg";